import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { applySessionToken } from "../lib/authSession";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function MagicLinkVerify() {
    const [params] = useSearchParams();
    const { refresh } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = params.get("token");
        if (!token) { setError("Missing token"); return; }
        (async () => {
            try {
                const { data } = await api.post("/auth/magic-link/verify", { token });
                applySessionToken(data);
                await refresh();
                toast(`Welcome${data.name ? `, ${data.name.split(" ")[0]}` : ""} ✨`);
                navigate(data.role === "admin" ? "/admin" : "/account", { replace: true });
            } catch (e) {
                setError(e.response?.data?.detail || "Invalid or expired link");
            }
        })();
    }, [params, refresh, navigate]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center container-boutique" data-testid="magic-verify-page">
            {error ? (
                <div className="card-soft p-10 text-center max-w-md">
                    <p className="font-serif text-2xl text-ink-900">Sign-in link issue</p>
                    <p className="text-ink-500 mt-3">{error}</p>
                    <a href="/login" className="btn-primary mt-6 inline-flex">Request a new link</a>
                </div>
            ) : (
                <p className="font-serif italic text-sage-700">Verifying your link…</p>
            )}
        </div>
    );
}
